import ForecastDate from "./ForecastDate";
import ConvertForecastTemperature from "./ConvertForecastTemperature";

import "./ForecastWeather.css";

export default function ForecastWeather(props) {
  return (
    <div className="weather-forecast">
      <div>
        <div className="weather-forecast-date">
          <ForecastDate date={new Date(props.forecast.time * 1000)} />
        </div>
        <div className="weather-forecast-icon">
          <img src={props.forecast.condition.icon_url} alt="weather icon" />
        </div>
        <div>
          <ConvertForecastTemperature
            tempMax={props.forecast.temperature.maximum}
            tempMin={props.forecast.temperature.minimum}
            unit={props.unit}
            setUnit={props.setUnit}
          />
        </div>
      </div>
    </div>
  );
}
